import { render, staticRenderFns } from "./sales-leads.vue?vue&type=template&id=669b2b61&scoped=true&"
import script from "./sales-leads.vue?vue&type=script&lang=js&"
export * from "./sales-leads.vue?vue&type=script&lang=js&"
import style0 from "./sales-leads.vue?vue&type=style&index=0&id=669b2b61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b2b61",
  null
  
)

export default component.exports